import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const metaTagsConfig = {
  '/': {
    title: 'Fasfas Games: Thrilling Crash, Casino & Casual Games for Kenyan Players',
    description: 'Fasfas Games is Kenya\'s top iGaming platform. Play crash, casino, and casual games for real money, secure payouts, exclusive cash rewards and non-stop excitement',
    keywords: 'Online gaming Kenya, Crash games Kenya, Slot games Kenya, Virtual games Kenya'
  },
  '/help/aboutUs': {
    title: 'About FasfasGames | Kenya\'s Leading Online Gaming Platform',
    description: 'Learn about FasfasGames, Kenya\'s premier online gaming platform offering crash games, slots, and virtual games with secure payments and exciting rewards.',
    keywords: 'About FasfasGames, Kenyan gaming platform, Online gaming Kenya'
  },
  '/signin': {
    title: 'Login to FasfasGames | Access Your Gaming Account',
    description: 'Sign in to your FasfasGames account to play crash games, slots, and win exciting rewards. Safe and secure gaming platform in Kenya.',
    keywords: 'Login FasfasGames, Gaming account Kenya, Online betting login'
  },
  '/signup': {
    title: 'Register on FasfasGames | Join Kenya\'s Top Gaming Site',
    description: 'Join FasfasGames - Kenya\'s leading gaming platform. Register now for exclusive bonuses, secure gaming, and instant payouts.',
    keywords: 'Register FasfasGames, Gaming registration Kenya, Online betting signup'
  },
  '/gamelaunch': {
    title: 'Game Play | Explore Crash, Slot & Virtual Games on FasfasGames',
    description: 'Play your favorite crash games, slots, and virtual games on FasfasGames. Experience thrilling gameplay and win real money.',
    keywords: 'Online games Kenya, Crash games, Slot games, Virtual gaming'
  },
  '/promotions': {
    title: 'Gaming Promotions | Exclusive Offers on FasfasGames Kenya',
    description: 'Discover exclusive gaming promotions and bonuses on FasfasGames. Boost your wins with special offers and rewards.',
    keywords: 'Gaming promotions Kenya, Betting offers, Casino bonuses'
  },
  '/help/responsibleGambling': {
    title: 'Responsible Gambling | Play Safely on FasfasGames',
    description: 'Learn about responsible gambling on FasfasGames. Get tips and tools to maintain control over your gaming activities.',
    keywords: 'Responsible gambling Kenya, Safe betting, Gaming limits'
  },
  '/loyalty': {
    title: 'Loyalty Program | Earn Rewards on FasfasGames Kenya',
    description: 'Join our loyalty program and earn exclusive rewards. Get special bonuses and privileges as you play on FasfasGames.',
    keywords: 'Loyalty rewards Kenya, Gaming benefits, Player rewards'
  },
  '/profile': {
    title: 'Profile | Customize Your FasfasGames Account',
    description: 'Manage your FasfasGames profile settings, update information, and customize your gaming experience.',
    keywords: 'Gaming profile, Account settings, Player preferences'
  },
  '/deposit': {
    title: 'Deposit Funds | Start Gaming on FasfasGames Kenya',
    description: 'Make secure deposits to your FasfasGames account. Multiple payment options available for Kenyan players.',
    keywords: 'Gaming deposits Kenya, Betting payments, Secure transactions'
  },
  '/withdraw': {
    title: 'Withdraw Winnings | Secure Transactions on FasfasGames',
    description: 'Withdraw your winnings safely and quickly from FasfasGames. Multiple withdrawal options available.',
    keywords: 'Gaming withdrawals Kenya, Betting payouts, Secure payments'
  },
  '/mybonuses': {
    title: 'My Bonuses | Claim Exclusive Offers on FasfasGames',
    description: 'Access and claim your exclusive bonuses on FasfasGames. Enjoy special rewards and promotions designed for Kenyan players.',
    keywords: 'Gaming bonuses Kenya, Casino rewards, Betting offers Kenya'
  },
  '/accountDetails': {
    title: 'Account Details | Manage Your FasfasGames Profile',
    description: 'View and manage your FasfasGames account details. Update your information and preferences for a better gaming experience.',
    keywords: 'Gaming account Kenya, Player profile, Account management'
  },
  '/bethistory': {
    title:   'Games History | Track Your Gameplay on FasfasGames',
    description: 'Track and review your betting history on FasfasGames. Monitor your gaming activity and outcomes.',
    keywords: 'Bet history Kenya, Gaming records, Betting tracker'
  },
  '/accounthistory': {
    title: 'Account History | Track Your Activity on FasfasGames',
    description: 'View your complete account activity history on FasfasGames. Monitor transactions, bets, and rewards.',
    keywords: 'Account history, Gaming activity, Transaction history Kenya'
  },
  '/bonushistory': {
    title: 'Bonus History | Track Your Rewards on FasfasGames',
    description: 'Review your bonus history and rewards on FasfasGames. Keep track of all your gaming bonuses and promotions.',
    keywords: 'Bonus history, Gaming rewards, Promotion tracker Kenya'
  },
  '/messagecenter': {
    title: 'Message Center | Stay Updated with FasfasGames',
    description: 'Access your FasfasGames message center. Stay updated with important notifications and announcements.',
    keywords: 'Gaming messages, Player notifications, Updates Kenya'
  },
  '/fasfascoins': {
    title: 'Fasfas Coins | Your Gaming Currency on FasfasGames',
    description: 'Manage your Fasfas Coins - the exclusive gaming currency. Earn and spend coins for enhanced gaming rewards.',
    keywords: 'Gaming coins, Loyalty points, Rewards currency Kenya'
  },
  '/my-bets': {
    title: 'My Bets | Track Your Active Bets on FasfasGames',
    description: 'Monitor your active bets and gaming activities on FasfasGames. Real-time updates on your current games.',
    keywords: 'Active bets, Current games, Betting tracker Kenya'
  },
  '/change-pin': {
    title: 'Change PIN | Secure Your FasfasGames Account',
    description: 'Update your account PIN on FasfasGames. Maintain the security of your gaming account.',
    keywords: 'Account security, PIN change, Safe gaming Kenya'
  },
  '/refer': {
    title: 'Refer and Earn | Invite Friends to FasfasGames Kenya',
    description: 'Participate in our refer-a-friend program. Earn rewards for inviting friends to join FasfasGames.',
    keywords: 'Refer friend, Gaming rewards, Referral bonus Kenya'
  },
  '/coins-history': {
    title: 'Fasfas Coins History | Manage Your Rewards on FasfasGames',
    description: 'Track your Fasfas Coins history. Monitor your earnings and usage of gaming rewards.',
    keywords: 'Coins history, Rewards tracking, Gaming points Kenya'
  },
  '/help/terms-conditions': {
    title: 'Terms & Conditions | FasfasGames User Agreement',
    description: 'Read and understand FasfasGames terms and conditions. Important information for Kenyan players.',
    keywords: 'Gaming terms, User agreement, Betting conditions Kenya'
  },
  '/help/bettingRules': {
    title: 'Betting Rules | Gaming Guidelines on FasfasGames',
    description: 'Learn about FasfasGames betting rules and guidelines. Understand how to play and bet responsibly.',
    keywords: 'Betting rules, Gaming guidelines, Fair play Kenya'
  },
  '/help/privacyPolicy': {
    title: 'Privacy Policy | Your Data Security on FasfasGames',
    description: 'Learn how FasfasGames protects your privacy and personal information. Secure gaming environment for Kenyan players.',
    keywords: 'Privacy policy, Data protection, Secure gaming Kenya'
  },
  '/help/amlpolicy': {
    title: 'AML Policy | Anti-Money Laundering Guidelines on FasfasGames',
    description: 'Understanding FasfasGames AML policy. Ensuring safe and legal gaming transactions in Kenya.',
    keywords: 'AML policy, Legal gaming, Safe transactions Kenya'
  },
  '/help/faq': {
    title: 'FAQ | Frequently Asked Questions about FasfasGames',
    description: 'Find answers to common questions about FasfasGames. Get help with gaming, payments, and account management.',
    keywords: 'Gaming FAQ, Help center, Support Kenya'
  },
  '/all-earnings': {
    title: 'All Earnings | Track Your Winnings on FasfasGames',
    description: 'View all your earnings and winnings on FasfasGames. Complete overview of your gaming success.',
    keywords: 'Gaming earnings, Winnings tracker, Profit history Kenya'
  }
};

const MetaTags = () => {
  const location = useLocation();
  
  useEffect(() => {
    const currentPath = location.pathname;
    const metaData = metaTagsConfig[currentPath] || metaTagsConfig['/'];

    document.title = metaData.title;
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', metaData.description);
    }

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', metaData.keywords);

  }, [location]);

  return null;
};

export default MetaTags;